import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FONT_FAMILY_MAP } from '../utils';
import infoCircleGreyIcon from 'assets/images/icons/info-circle.svg';
import InfoTooltip from 'components/common-components/InfoTooltip';
import linkGreenIcon from 'assets/images/icons/link-green.svg';

const ChartHeader = ({ widget }) => {
  const { basicProps, advancedProps } = widget;
  const captionFontFamily = FONT_FAMILY_MAP[advancedProps.captionFontWeight] || '';

  return (
    <Fragment>
      {!['textCard', 'imageCard'].includes(basicProps.chartType) && (
        <div className='widget-header d-flex align-items-center align-self-start px-3 py-2 gap-2'>
          {basicProps.caption && (
            <span
              style={{ fontSize: advancedProps.captionFontSize, fontFamily: captionFontFamily }}
            >
              {basicProps.caption}
            </span>
          )}
          {!['statsCard'].includes(basicProps.chartType) && (
            <Fragment>
              {advancedProps.tooltip && (
                <InfoTooltip
                  text={advancedProps.tooltip}
                  triggerElement={<img src={infoCircleGreyIcon} />}
                />
              )}
              {advancedProps.linkedPageId && (
                <img
                  className='cursor-pointer'
                  src={linkGreenIcon}
                  onClick={() => {
                    window.open(
                      `/dashboards/navigate/${advancedProps.linkedDashboardId}/${advancedProps.linkedPageId}`,
                      '_blank',
                    );
                  }}
                />
              )}
            </Fragment>
          )}
        </div>
      )}
    </Fragment>
  );
};

ChartHeader.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default ChartHeader;
